/* Home: hero text reveal + play/pause, reel wall, shape quiz */
(function () {
  'use strict';
  const $ = (s, c) => (c || document).querySelector(s), $$ = (s, c) => Array.from((c || document).querySelectorAll(s));
  const LANG = document.body.dataset.lang || 'en';
  /* hero */
  const hero = $('.hero');
  if (hero) {
    const title = $('.hero__title', hero);
    if (title && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      title.innerHTML = title.textContent.trim().split(/\s+/).map((w, i) => `<span class="w"><span style="transition-delay:${120 + i * 90}ms">${w}</span></span>`).join(' ');
    }
    requestAnimationFrame(() => requestAnimationFrame(() => hero.classList.add('is-ready')));
    setTimeout(() => hero.classList.add('is-ready'), 600);
    setTimeout(() => $$('.hero__title .w span').forEach(s => { s.style.transform = 'none'; }), 2600);
    const v = $('video', hero), btn = $('.hero__play', hero);
    if (v && v.dataset.mobile && window.innerWidth < 760 && window.innerHeight > window.innerWidth) { v.poster = v.dataset.posterMobile || v.poster; v.src = v.dataset.mobile; v.load(); const p = v.play(); if (p && p.catch) p.catch(() => { }); }
    if (v && btn) { btn.addEventListener('click', () => { if (v.paused) { v.play(); btn.classList.remove('is-paused'); } else { v.pause(); btn.classList.add('is-paused'); } }); }
    const scroll = $('.hero__scroll', hero); scroll && scroll.addEventListener('click', () => { const n = hero.nextElementSibling; n && n.scrollIntoView({ behavior: 'smooth' }); });
  }
  /* reels: tap to toggle sound-free play/pause */
  $$('.reel').forEach(r => { const v = $('video', r); const b = $('.reel__play', r); b && b.addEventListener('click', () => { if (v.paused) v.play(); else v.pause(); r.classList.toggle('is-paused', v.paused); }); });
  /* ticker duplication for seamless loop */
  const tt = $('.ticker__track'); if (tt) tt.innerHTML += tt.innerHTML;
  /* quiz */
  const quiz = $('[data-quiz]');
  if (quiz) {
    const T = {
      en: { q: ['How do you wear your natural nails?', 'Your finger shape?', 'The look you\'re after?'], a: [['Short, I use my hands all day', 'Medium', 'I like some length'], ['Slim and long', 'Average', 'Wide nail beds'], ['Soft & natural', 'Polished & classic', 'Bold & dramatic']] },
      fr: { q: ['Comment portez-vous vos ongles naturels?', 'La forme de vos doigts?', 'Le style recherché?'], a: [['Courts, je travaille avec mes mains', 'Moyens', 'J\'aime un peu de longueur'], ['Fins et longs', 'Dans la moyenne', 'Lits d\'ongles larges'], ['Doux et naturel', 'Soigné et classique', 'Audacieux et dramatique']] }
    }[LANG];
    const R = JSON.parse(quiz.dataset.results); // {shapeKey: {name, text}}
    const qEl = $('[data-quiz-q]', quiz), optsEl = $('[data-quiz-opts]', quiz), steps = $$('.quiz__steps i', quiz), nailUse = $('[data-quiz-nail] use', quiz), res = $('[data-quiz-result]', quiz);
    let step = 0; const ans = [];
    const previews = ['short-oval', 'squoval', 'almond'];
    function render() {
      steps.forEach((s, i) => s.classList.toggle('is-on', i <= step));
      qEl.textContent = T.q[step];
      optsEl.innerHTML = T.a[step].map((a, i) => `<button type="button" class="quiz__opt" data-i="${i}">${a}</button>`).join('');
    }
    function result() {
      const [len, finger, look] = ans; // 0..2 each
      let key;
      if (len === 0) key = look === 2 ? 'short-coffin' : finger === 2 ? 'short-oval' : look === 0 ? 'short-oval' : 'squoval';
      else if (len === 1) key = look === 2 ? 'short-coffin' : look === 0 ? 'short-almond' : finger === 0 ? 'short-almond' : 'squoval';
      else key = look === 2 ? 'coffin' : look === 1 ? 'almond' : finger === 2 ? 'almond' : 'almond';
      const r = R[key]; nailUse.setAttribute('href', '#shape-' + key);
      $('[data-quiz-name]', res).textContent = r.name; $('[data-quiz-text]', res).textContent = r.text;
      const link = $('[data-quiz-link]', res); link.href = link.dataset.base + '?s=' + key + (key.startsWith('short') || key === 'squoval' ? '' : '');
      quiz.classList.add('is-done');
    }
    optsEl.addEventListener('click', e => {
      const b = e.target.closest('.quiz__opt'); if (!b) return; ans[step] = +b.dataset.i;
      $$('.quiz__opt', optsEl).forEach(x => x.classList.toggle('is-on', x === b));
      nailUse.setAttribute('href', '#shape-' + (step === 0 ? previews[ans[0]] : step === 2 && ans[2] === 2 ? 'coffin' : previews[ans[0]]));
      setTimeout(() => { if (step < 2) { step++; render(); } else result(); }, 320);
    });
    $('[data-quiz-restart]', quiz).addEventListener('click', () => { step = 0; ans.length = 0; quiz.classList.remove('is-done'); nailUse.setAttribute('href', '#shape-almond'); render(); });
    render();
  }
})();

/* ---- the wardrobe ----
   Accordion, not hover: a hover-opened drawer fires on every pass of the mouse
   and cannot be operated by touch or keyboard; a button with aria-expanded
   works for all three. Every tray is rendered open so the page is whole with
   JavaScript off; the `js` class on <html> switches the collapse on, and the
   first drawer stays open so the mechanism is self-evident. */
(function () {
  const stack = document.querySelector('[data-wardrobe]');
  if (!stack) return;
  document.documentElement.classList.add('js');
  const draws = Array.from(stack.querySelectorAll('[data-draw]'));
  const set = (d, open) => {
    d.classList.toggle('is-open', open);
    d.querySelector('.draw__pull').setAttribute('aria-expanded', String(open));
  };
  draws.forEach((d, i) => set(d, i === 0));
  stack.addEventListener('click', e => {
    const btn = e.target.closest('.draw__pull');
    if (!btn) return;
    const d = btn.closest('[data-draw]');
    const opening = !d.classList.contains('is-open');
    draws.forEach(x => set(x, x === d && opening));
    if (opening) {
      /* Keep the pull in view when a tall tray above it collapses. */
      setTimeout(() => {
        const r = btn.getBoundingClientRect();
        if (r.top < 90) window.scrollBy({ top: r.top - 100, behavior: 'smooth' });
      }, 380);
    }
  });
})();
